import React from "react";

const Pagination = ({
    currentPage,
    totalPages,
    onPageChange,
    pageSize,
    setPageSize,
    totalCount
}) => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    return (
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mt-24">
            <div className="d-flex align-items-center gap-2">
                <span className="text-secondary-light text-sm">Gösterilen:</span>
                <select
                    className="form-select form-select-sm w-auto radius-8"
                    value={pageSize}
                    onChange={(e) => setPageSize(Number(e.target.value))}
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <span className="text-secondary-light text-sm">
                    Toplam {totalCount} kayıt içerisinde
                </span>
            </div>

            <nav aria-label="Page navigation">
                <ul className="pagination pagination-sm d-flex align-items-center gap-2 mb-0">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link w-32-px h-32-px radius-8 d-flex align-items-center justify-content-center border-neutral-300"
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            <i className="ri-arrow-left-s-line"></i>
                        </button>
                    </li>

                    {startPage > 1 && (
                        <>
                            <li className="page-item">
                                <button className="page-link w-32-px h-32-px radius-8 d-flex align-items-center justify-content-center border-neutral-300" onClick={() => onPageChange(1)}>1</button>
                            </li>
                            {startPage > 2 && <li className="page-item disabled"><span className="page-link border-0">...</span></li>}
                        </>
                    )}

                    {pages.map(page => (
                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                            <button
                                className={`page-link w-32-px h-32-px radius-8 d-flex align-items-center justify-content-center ${currentPage === page ? 'bg-primary-600 text-white border-primary-600' : 'border-neutral-300 text-secondary-light'}`}
                                onClick={() => onPageChange(page)}
                            >
                                {page}
                            </button>
                        </li>
                    ))}

                    {endPage < totalPages && (
                        <>
                            {endPage < totalPages - 1 && <li className="page-item disabled"><span className="page-link border-0">...</span></li>}
                            <li className="page-item">
                                <button className="page-link w-32-px h-32-px radius-8 d-flex align-items-center justify-content-center border-neutral-300" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
                            </li>
                        </>
                    )}

                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                            className="page-link w-32-px h-32-px radius-8 d-flex align-items-center justify-content-center border-neutral-300"
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            <i className="ri-arrow-right-s-line"></i>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Pagination;
